import React from 'react';
import Select from 'react-select';
import { EVENTS } from '../../utilities/CONSTANTS';
import { getPagesOwnerUrl } from '../../utilities/urlHelper';

class BulkChangePageOwnerModal extends React.Component {
    state = {
        users: null,
        selectedOption: null,
        isSaving: false,
        pageCount: 0,
    };

    componentDidMount() {
        if (window._referencableTettraUsers) {
            this.setUsers();
        } else {
            window.addEventListener(EVENTS.USERS_LOADED, this.setUsers);
        }
    }

    componentWillUnmount() {
        window.removeEventListener(EVENTS.USERS_LOADED, this.setUsers);
    }

    setUsers = () => {
        const users = (window._referencableTettraUsers || [])
            .map(u => ({ value: u.id, label: u.display_name }))
            .filter(u => u.value);
        const { selectedPages } = this.props;
        const pageCount = selectedPages?.length || 0;

        this.setState({ users, pageCount });
    };

    render() {
        const {
            users, selectedOption, isSaving, pageCount,
        } = this.state;
        const { closeModal, selectedPages } = this.props;
        const noPagesSelected = pageCount < 1;
        const isDisabled = !selectedOption || isSaving || noPagesSelected;
        const btnClass = isSaving || noPagesSelected ? 'btn btn-primary is-disabled' : 'btn btn-primary';
        const btnText = isSaving ? 'Saving...' : 'Save';
        const pageIds = Array.isArray(selectedPages) ? selectedPages.join(',') : '';

        return (
            <div className="react-modal open" role="dialog" aria-labelledby="change-owner-title" aria-modal="true">
                <div className="modal-content">
                    <form
                        method="POST"
                        action={getPagesOwnerUrl()}
                        onSubmit={() => this.setState({ isSaving: true })}
                    >
                        <h2>Change Owner</h2>
                        <div className="mt2 mb2 flex italic">
                            {noPagesSelected
                                ? (
                                    <>
                                    Please select at least one page.
                                    </>
                                )
                                : (
                                    <>
                                  You are changing ownership of
                                &nbsp;
                                        <strong>{pageCount}</strong>
                                &nbsp;
                                        {pageCount === 1 ? 'page' : 'pages'}
                                .
                                    </>
                                )}
                        </div>
                        {!users
                            ? <span className="grey loading">Loading</span>
                            : (
                                <Select
                                    placeholder="Select new owner"
                                    value={selectedOption}
                                    onChange={(selectedOption) => this.setState({ selectedOption })}
                                    options={users}
                                    isDisabled={noPagesSelected}
                                    autoFocus
                                />
                            )}
                        <input name="_token" type="hidden" value={window.csrfToken} />
                        <input type="hidden" name="page_ids" value={pageIds} />
                        <input type="hidden" name="owner_id" value={selectedOption?.value || ''} />
                        <div className="right-align mt3">
                            <span className="btn-secondary mr1" onClick={closeModal}>Close</span>
                            <button type="submit" className={btnClass} disabled={isDisabled}>
                                {btnText}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default BulkChangePageOwnerModal;
